import { useEffect, useState } from "react";
import { Card } from "@mui/material";
import { handleAxiosError } from "app/services/app.error.handler";
import { loadAllClientProjects } from "app/services/client-project.service";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AddClientProjectDialog from "./AddClientProjectDialog";
import { ClientProjectsDataGrid } from "./ClientProjectsDataGrid";

/**
 * Master data card for client projects, modelled on AllActivityTypesView.
 *
 * Holds the project list in local state rather than a Redux slice: nothing outside this screen
 * needs the full cross-client list, and the Add Activity dialog fetches per client instead.
 *
 * @since NEXT_VERSION
 */
const AllClientProjectsView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editObject, setEditObject] = useState(null);
  const [projects, setProjects] = useState([]);

  const refreshHandler = () => {
    setIsLoading(true);
    loadAllClientProjects()
      .then((response) => setProjects(Array.isArray(response.data) ? response.data : []))
      .catch((error) => {
        setProjects([]);
        handleAxiosError(error);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    refreshHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editEventHandler = (data) => {
    setEditObject(data);
    setOpen(true);
  };

  return (
    <div style={{ width: "100%" }}>
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={1}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h6" color="white">
            All Client Projects
          </MDTypography>
        </MDBox>
        <MDBox height={500} mb={0} sx={{ overflowX: "auto" }}>
          <ClientProjectsDataGrid
            projects={projects}
            isLoading={isLoading}
            onAddProject={() => {
              setEditObject(null);
              setOpen(true);
            }}
            editEventHandler={editEventHandler}
          />
        </MDBox>
      </Card>
      <AddClientProjectDialog
        open={open}
        setOpen={setOpen}
        refreshProjectsHandler={refreshHandler}
        editObject={editObject}
      />
    </div>
  );
};

export default AllClientProjectsView;
